import React, { Component } from 'react';
import { Grid, Typography, Paper } from '@material-ui/core';
import styled from 'styled-components';
import { connect } from 'react-redux';
import SummaryReportNumberView from './SummaryReportNumberView';
import WeekFeesTable from './WeekFeesTable';
import SalesRepBarChart from './SalesRepBarChart';
import RankTable from './RankTable';
import SalesRepFilter from './SalesRepFilter';
import SalesRepPieChart from './SalesRepPieChart';
import VehicleFeesModal from './VehicleFeesModal';
import { modalsToggle } from '../../../../actions';

const modalName = 'vehiclesBuyFeesModal';

const StyledTypography = styled(Typography)`
  font-weight: bolder;
  font-size: 14px;
  padding: 23px 0;
`;

const Box = styled('div')`
  && {
    display: flex;
    flex-wrap: nowrap;
  }
  && > div {
    flex-grow: 1;
    border-right: 1px dashed #d7d7d7;
    padding-left: 20px;
  }
  && > div:last-child {
    border-right: none;
  }
  && > div:first-child {
    padding-left: 0;
  }
`;

const summarySellRows = [
  { type: 'sell_due', label: 'Sell Fees Due' },
  { type: 'sell_net', label: 'Sell Fees Net' }
];

const summaryBuyRows = [
  { type: 'buy_credit_card', label: 'Buy Fees Credit Card' },
  { type: 'buy_floor', label: 'Buy Fees Floored' },
  { type: 'buy_ach', label: 'Buy Fees ACH' },
  { type: 'buy_transport', label: 'Transport Fees' }
];

function patchUtcDates(summaryVehicles) {
  return summaryVehicles
    .filter(vehicle => !isNaN(new Date(vehicle.date)))
    .map(vehicle => {
      const utcDate = new Date(vehicle.date);
      if (utcDate.toISOString().endsWith('T00:00:00.000Z')) {
        // this was a db date only
        const localDate = new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
        return { ...vehicle, date: localDate.toISOString() };
      }
      return vehicle;
    });
}

class SummaryReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehiclesModalType: 'buy_credit_card'
    };
    this.setVehicleModalFilters = this.setVehicleModalFilters.bind(this);
  }

  setVehicleModalFilters(type) {
    const { toggleModal } = this.props;
    toggleModal(modalName);
    this.setState({
      vehiclesModalType: type
    });
  }

  render() {
    const { data, print } = this.props;
    const { vehiclesModalType } = this.state;
    if (!data || !data.data) {
      const message = data && data.message ? data.message : 'Could not retrieve data';
      return <Typography>{message}</Typography>;
    }
    const report = data.data;
    report.summary_vehicles = patchUtcDates(report.summary_vehicles);
    return (
      <Paper style={print ? { boxShadow: 'none', padding: 0 } : { padding: '0 40px' }}>
        <StyledTypography variant="title">AUCTION TOTALS</StyledTypography>
        <Box>
          <SummaryReportNumberView
            title="Vehicles Listed"
            value={report.vehicles_listed}
            prevValue={report.vehicles_listed_prev}
          />
          <SummaryReportNumberView
            title="Vehicles Sold"
            value={report.vehicles_sold}
            prevValue={report.vehicles_sold_prev}
          />
          <SummaryReportNumberView
            title="Not Sold"
            value={report.vehicles_not_sold}
            prevValue={report.vehicles_not_sold_prev}
          />
          <SummaryReportNumberView
            title="Pulled"
            value={report.vehicles_pulled}
            prevValue={report.vehicles_pulled_prev}
          />
          <SummaryReportNumberView
            title="$ Avg. Sell Price"
            value={report.avg_sell_price}
            prevValue={report.avg_sell_price_prev}
            isUsd
          />
          <SummaryReportNumberView
            title="$ Auction Revenue"
            value={report.auction_profit}
            prevValue={report.auction_profit_prev}
            isUsd
          />
        </Box>

        <br />
        <StyledTypography variant="title">BUY FEES</StyledTypography>
        <Box>
          <SummaryReportNumberView title="$ Buy Fees" value={report.buy_fees} prevValue={report.buy_fees_prev} isUsd />
          <SummaryReportNumberView
            title="$ Avg. Buy Fee"
            value={report.avg_buy_fee}
            prevValue={report.avg_buy_fee_prev}
            isUsd
          />
          <SummaryReportNumberView
            title="$ Credit Card Fees"
            value={report.credit_card_fees}
            prevValue={report.credit_card_fees_prev}
            isUsd
          />
          <SummaryReportNumberView title="$ ACH Fees" value={report.ach_fees} prevValue={report.ach_fees_prev} isUsd />
          <SummaryReportNumberView
            title="$ Flooring Fees"
            value={report.flooring_fees}
            prevValue={report.flooring_fees_prev}
            isUsd
          />
          <SummaryReportNumberView
            title="$ Additional Fees"
            value={report.additional_fees}
            prevValue={report.additional_fees_prev}
            isUsd
          />
          <SummaryReportNumberView
            title="$ Transportation Fees"
            value={report.transportation_fees}
            prevValue={report.transportation_fees_prev}
            isUsd
          />
        </Box>

        <br />
        <br />
        <br />
        <Grid container spacing={16}>
          <Grid item md={5}>
            <div style={{ border: '1px solid #CECECE', borderRadius: 8, padding: '0 20px' }}>
              <StyledTypography variant="title" style={{ paddingBottom: 10 }}>
                EasyPay Rank
              </StyledTypography>
              <RankTable rows={report.easy_pay_rank} />
            </div>
          </Grid>
          <Grid item md={7}>
            <div style={{ border: '1px solid #CECECE', borderRadius: 8, padding: '0 20px' }}>
              <WeekFeesTable
                setFilters={this.setVehicleModalFilters}
                data={report.summary_vehicles}
                rows={summaryBuyRows}
              />
            </div>
          </Grid>
        </Grid>

        <br />
        <br />
        <Grid container spacing={16}>
          <Grid item md={5}>
            <StyledTypography variant="title">SELL FEES</StyledTypography>
            <Box>
              <SummaryReportNumberView
                title="$ Sell Fees"
                value={report.sell_fees}
                prevValue={report.sell_fees_prev}
                isUsd
              />
              <SummaryReportNumberView
                title="$ Sell Fees Due"
                value={report.sell_fees_due}
                prevValue={report.sell_fees_due_prev}
                isUsd
              />
              <SummaryReportNumberView
                title="$ Sell Fees Net"
                value={report.sell_fees_net}
                prevValue={report.sell_fees_net_prev}
                isUsd
              />
            </Box>
          </Grid>
          <Grid item md={7}>
            <div style={{ border: '1px solid #CECECE', borderRadius: 8, padding: '0 20px' }}>
              <WeekFeesTable
                setFilters={this.setVehicleModalFilters}
                data={report.summary_vehicles}
                rows={summarySellRows}
              />
            </div>
          </Grid>
        </Grid>

        <br />
        <br />
        <Grid container>
          <Grid item md={10}>
            <StyledTypography variant="title" style={{ float: 'left' }}>
              SALES REP PERFORMANCE
            </StyledTypography>
            <SalesRepFilter allReps={report.performance.map(performance => performance.name)} />
            <div
              style={{
                fontSize: 12,
                marginTop: 20,
                borderRadius: 8,
                boxShadow: '0px 4px 8px rgba(37, 40, 43, 0.14)',
                width: 600,
                height: 300
              }}
            >
              <SalesRepBarChart data={report.performance} />
              <SalesRepPieChart data={report.performance} />
            </div>
          </Grid>
        </Grid>

        <br />
        <br />
        <VehicleFeesModal
          vehicles={report.summary_vehicles}
          type={vehiclesModalType}
          rows={[...summaryBuyRows, ...summarySellRows]}
        />
      </Paper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  toggleModal: key => dispatch(modalsToggle(key))
});

export default connect(null, mapDispatchToProps)(SummaryReportContainer);
